<template>
  <!-- v-show="custom.searchList && custom.searchList.length>0" -->
  <div class="dynamic-query" v-loading="!custom || custom.searchList.length===0" element-loading-spinner="none">
    <el-form ref="form" :model="form" :inline="true" class="search-form custom-form">
      <el-form-item label="分支机构" key="index" v-if="isUltimate">
        <ybl-multi-select v-model="partner.defaultVal" :items="partner.branchList" :props="partner.props" :placeholder="`请选择分支机构`" clearable
          filterable :filter-method="filterPartner" @focus="focusPartner" @change="partnerChange($event)"></ybl-multi-select>
      </el-form-item>
      <template v-for="(item,index) in custom.searchList">
        <ybl-date-time :key="index" v-model="item.defaultVal" v-if="+item.frontEleType===11" :diff="2" unit="y"></ybl-date-time>
        <el-form-item :label="`${item.showName}`" :key="index"
          :class="{'ultimate-item':isUltimate && index===0,'el-form-item__long':item.showName.length>=18}" v-else>
          <ybl-insurance-type v-model="item.defaultVal"
            v-if="+item.id===1533 || `${item.tableName}_${item.fieldName}`==='insuranceinfo_InsuranceTypes'" :showCheckbox="+item.isMutiSelect===1"
            :placeholder="`请选择${item.showName}`">
          </ybl-insurance-type>
          <ybl-insurance-type v-model="item.defaultVal" v-else-if="+item.id===1575" :showCheckbox="true" :dataType="4"
            :placeholder="`请选择${item.showName}`" :props="props">
          </ybl-insurance-type>
          <ybl-select-tree v-model="item.defaultVal" :items="item.dictList" :props="treeDefaultProps" :placeholder="`请选择${item.showName}`" clearable
            :ref="`stree_${item.id}`" @clear="treeClear(item)"
            v-else-if="[10].includes(+item.frontEleType) && ![1533,1575].includes(+item.id)"></ybl-select-tree>
          <ybl-radio-group label="" v-bind:checked.sync="item.defaultVal" :showClose="true" :options="item.dictList" :props="defaultProps"
            label-width="100px" v-else-if="item.isTabFilter" @change="radioChange">
          </ybl-radio-group>
          <ybl-multi-select v-model="item.defaultVal" :items="item.dictList" :props="+item.sourceType===2?staticProps:jobnumProps"
            :placeholder="`请选择${item.showName}`" clearable filterable v-else-if="[2,3].includes(+item.frontEleType) && +item.isMutiSelect===1"
            :filter-method="filterEvent" @focus="focusEvent(item)" @change="relationChange($event,item)">
          </ybl-multi-select>
          <el-select :ref="item.id" v-model="item.defaultVal" :placeholder="`请选择${item.showName}`" :filterable="true" clearable
            v-else-if="[2,3].includes(+item.frontEleType) && +item.isMutiSelect===0" :filter-method="filterEvent" @focus="focusEvent(item)">
            <el-option v-for="o in item.dictList" :key="o.keyCode || o.Value" :label="getLabel(item,o)" :value="o.keyCode || o.Value"></el-option>
          </el-select>
          <!-- :multiple="+item.isMutiSelect===1" :collapse-tags="+item.isMutiSelect===1" :class="{'el-select-multiple__custom':+item.isMutiSelect===1}" -->
          <ybl-date-range v-model="item.defaultVal" v-else-if="item.frontEleType===8" :diff="2" unit="y"></ybl-date-range>
          <el-date-picker v-model="item.defaultVal" type="date" placeholder="选择日期" v-else-if="item.frontEleType===7">
          </el-date-picker>
          <ybl-area v-model="item.defaultVal" :labels="['','','']" :level="2" v-else-if="+item.frontEleType===5">
          </ybl-area>
          <ybl-area :labels="['','','']" v-else-if="+item.frontEleType===6"></ybl-area>
          <ybl-num-range v-model="item.defaultVal" v-else-if="+item.frontEleType===9"></ybl-num-range>
          <el-input type="text" v-model="item.defaultVal" :placeholder="`请输入${item.showName}`" v-else clearable>
          </el-input>
        </el-form-item>
      </template>
      <el-form-item label="">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
        <el-link type="primary" @click="open">条件设置<i class="el-icon-edit-outline el-icon--right"></i> </el-link>
      </el-form-item>
    </el-form>
    <ybl-list-panel :title="title">
      <template slot="header">
        <div>
          <slot name="header-left" v-if="showTask && !isdataauthority">
            <el-button type="text" @click="goToRouter('/feiche/policy/task?showType=delete')" v-if="isFeiche">任务列表
            </el-button>
            <el-button type="text" @click="goToRouter(`/insurance/task?busiType=${sceneCategory}`)" v-else>任务列表
            </el-button>
          </slot>
        </div>
        <div :class="{'custom-action':showExport}">
          <slot name="custom-action"></slot>
          <el-dropdown type="primary" @command="handleCommand" v-if="showExport" v-authority="exportAuthority" :hide-on-click="false">
            <el-button type="primary">
              保单导出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="none">
                <el-input type="text" v-model="templateVal" clearable placeholder="请输入模版名称进行检索" @input="inputChange"></el-input>
              </el-dropdown-item>
              <el-dropdown-item :command="item.id" v-for="(item,index) in templateList" :divided="index===0" :key="item.id">{{item.sceneName}}
              </el-dropdown-item>
              <el-dropdown-item command="item.id" divided key="item.id"></el-dropdown-item>
              <el-dropdown-item :divided="false" icon="el-icon-plus" v-if="!isFeiche && +dynamicQueryType!==4" command="addTemplate" key="addTemplate"
                v-authority="customExportTemplate">自定义表头</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="openColumn" v-if="![4].includes(+dynamicQueryType)">列表字段设置</el-button>
        </div>
      </template>
      <div class="summary-info">
        <!-- 共{{queryTotal}}条 &nbsp;&nbsp;总保费
        <span>{{sumInsuranceInfo.totalPrice && sumInsuranceInfo.totalPrice.toFixed(2) || 0}}</span> 元 &nbsp;&nbsp;总净保费
        <span>{{sumInsuranceInfo.sumNetPremium && sumInsuranceInfo.sumNetPremium.toFixed(2) || 0}}</span> 元 &nbsp;&nbsp;车船税
        <span>{{sumInsuranceInfo.vvtax && sumInsuranceInfo.vvtax.toFixed(2) || 0}}</span> 元 &nbsp;&nbsp;应结保单手续费
        <span>{{sumInsuranceInfo.salesmanSettlePrice && sumInsuranceInfo.salesmanSettlePrice.toFixed(2) || 0}}</span> 元 &nbsp;&nbsp;未结保单手续费
        <span>{{sumInsuranceInfo.salesmanSettlePrice && (+sumInsuranceInfo.salesmanSettlePrice - +(sumInsuranceInfo.salesmanRealSettlePrice || 0)).toFixed(2) || 0}}</span> 元 &nbsp;&nbsp;应结区域奖励
        <span>{{sumInsuranceInfo. salesmanVVTaxSettlePrice && sumInsuranceInfo. salesmanVVTaxSettlePrice.toFixed(2) || 0}}</span> 元 &nbsp;&nbsp;未结区域奖励
        <span>{{sumInsuranceInfo.salesmanVVTaxSettlePrice && (sumInsuranceInfo.salesmanVVTaxSettlePrice - +(sumInsuranceInfo.salesmanVVTaxRealSettlePrice || 0)).toFixed(2) || 0}}</span> 元 -->
        <slot></slot>
      </div>
      <ybl-table ref="dynamicTable" :data="queryList" border :total="queryTotal" :change="pageChange" :nowrap="true"
        @selection-change="handleSelectionChange" @size-change="sizeChange">
        <el-table-column :type="type" align="center" fixed="left" label="序号"></el-table-column>
        <el-table-column label="分支机构" align="center" min-width="100" fixed v-if="isUltimate">
          <template slot-scope="scope">
            {{scope.row.fields['666']}}
          </template>
        </el-table-column>
        <template v-for="(item,index) in custom.availableList">
          <el-table-column :label="item.showName" align="center" min-width="120" show-overflow-tooltip :key="`column_${index}`" :prop="`${item.id}`"
            :fixed="index<2" v-if="![1578, 1579, 1580, 1577, 1582, 1581, 1576].includes(item.id)">
            <template slot-scope="scope">
              <template v-if="[2,3,10].includes(+item.frontEleType)">
                <span v-if="isFeiche">{{scope.row.fields[item.id]}}</span>
                <span v-else
                  :class="{'red':[1277,1282,1562,1563].includes(item.id) && +scope.row.fields[item.id]===0}">{{calcFieldText(item.id,scope.row,item,scope.$index)}}</span>
              </template>
              <template v-else-if="+item.showFormatType===1">
                <span v-if="`${item.tableName}_${item.fieldName}`==='insurancesettle_RewardSettleRate' && +dynamicQueryType===4">
                  {{scope.row.fields[item.id] | percent}} <i class="el-icon-caret-bottom cursor" @click="openView(scope.row)"></i>
                </span>
                <span v-else>{{scope.row.fields[item.id] | percent}}</span>
              </template>
              <template v-else-if="+item.showFormatType===2">
                {{scope.row.fields[item.id] | dateFormat}}
              </template>
              <template v-else-if="+item.showFormatType===3">
                {{scope.row.fields[item.id] | Currency}}
              </template>
              <template v-else-if="+item.id===1166">
                <!-- 保单号 特殊处理 -->
                <span v-if="isUltimate">{{scope.row.fields[item.id]}}</span>
                <span class="cursor primary-color" @click="goToDetail(scope.row)" v-else>{{scope.row.fields[item.id]}}</span>
              </template>
              <template v-else>
                {{scope.row.fields[item.id]}}
              </template>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="关联政策" align="center" min-width="100" v-if="showRelation" v-isdataauthority>
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-paperclip" :class="{'disabled':!renderPolicy(scope.row)}" @click="viewPolicy(scope.row)"></el-button>
          </template>
        </el-table-column>
        <slot name="action">
          <!-- <el-table-column label="操作" align="center" fixed="right" min-width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column> -->
        </slot>
      </ybl-table>
    </ybl-list-panel>
    <ybl-dialog :visible="dialog.visible" :title="dialog.title" :width="dialog.width" @close="close" @confirm="dialogSubmit"
      :showFooter="![17,50,400].includes(+dialog.step) || isBindQrcode" :showHeader="![50].includes(+dialog.step)">
      <ybl-condition ref="dialog" v-if="+dialog.step<3" :fields="system[renderField]" v-model="custom[renderField]" @change="submit"
        :groupCheckBox="+dialog.step===2"></ybl-condition>
      <template-fields ref="dialog" v-else-if="+dialog.step===40" :item="currentTemplate" @change="submitTemplate"
        :templates="originTemplateList"></template-fields>
      <ybl-qrcode ref="dialog" v-else-if="+dialog.step===400" @next="nextValidate"></ybl-qrcode>
      <ybl-export ref="dialog" v-else :taskId="taskId" :isFeiche="isFeiche" :busiType="sceneCategory" @close="close" @goTo="goTo"></ybl-export>
    </ybl-dialog>
  </div>
</template>

<script>
import yblCondition from '@/views/finance/settlement/condition'
import templateFields from '@/views/finance/components/templateFields'
// import insuranceTypeTree from '@/views/feiche/components/entering/insuranceTypeTree'
import request from '@/services/base'
import { field } from '@/data/field'
import { openNavUrl, isDataAuthority, tool, day } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'yblDynamicQuery',
  props: {
    sceneCategory: { // 筛选场景类型
      type: Number | String,
      default: () => 1
    },
    productType: { // 产品类型 0 所有 1 车险 2 非车 3 寿险
      type: Number | String,
      default: () => '1'
    },
    exportSceneCategory: { // 导出模版场景类型
      type: Number | String,
      default: () => 2
    },
    title: {
      type: String,
      default: () => '保单列表'
    },
    showTask: { // 是否显示任务列表跳转链接
      type: Boolean,
      default: () => false
    },
    type: { // 首列的显示类型
      type: String,
      default: () => 'index'
    },
    isUltimate: { // 是否 旗舰版 （多商户查询）
      type: Boolean,
      default: () => false
    },
    isFeiche: { // 是否非车
      type: Boolean,
      default: () => false
    },
    showRelation: { // 是否显示关联政策
      type: Boolean,
      default: () => false
    },
    showExport: { // 是否显示导出功能
      type: Boolean,
      default: () => true
    },
    exportAuthority: { // 导出权限值
      type: String | Number | Array,
      default: () => '0000' // '0000'表示拥有权限
    },
    customExportTemplate: { // 自定义导出模版权限
      type: String | Number | Array,
      default: () => '0000' // '0000'表示拥有权限
    },
    dynamicQueryType: {
      type: String | Number,
      default: () => '' //  0 保单查询 1 财务明细 2下游结算 3 上游结算 4 奖励结算
    }
  },
  data () {
    return {
      form: {},
      queryList: [],
      queryTotal: 0,
      dialog: {
        visible: false,
        title: '查询条件设置',
        width: '',
        step: 1 // 1 条件设置 2 列表字段设置
      },
      custom: {
        scene: {},
        searchList: [],
        availableList: []
      },
      system: {
        scene: {},
        searchList: [],
        availableList: []
      },
      sceneList: [],
      templateList: [],
      originTemplates: [],
      templateVal: '',
      originTemplateList: [], // 原始导出模版
      originFields: [],
      rightFields: [],
      defaultProps: {
        label: 'keyVal',
        value: 'keyCode'
      },
      treeDefaultProps: {
        children: 'Childrens',
        label: 'Label',
        id: 'Value',
        disabled: 'Status'
      },
      jobnumProps: {
        label: 'Label',
        value: 'Value',
        disabled: 'Status',
        disabledValue: 9
      },
      staticProps: {
        label: 'keyVal',
        value: 'keyCode'
      },
      renderField: '', // condition设置渲染字段
      dynamicDataList: {}, // 动态数据集合
      currentSelectedItem: '', // 当前操作下拉框对象
      currentSearchCondition: '',
      multipleSelection: [],
      currentCommand: '', // 当前操作命令（结算）
      sumInsuranceInfo: {},
      currentTemplate: { label: '下游结算报表模版', status: '', value: 40, childrens: [] },
      partner: {
        branchList: [], // 存储旗舰版下 （子商户）
        props: { label: 'partnerName', value: 'partnerId' },
        defaultVal: [],
        originBranchList: []
      },
      haveCustomScene: false, // 是否有自定义场景
      pageSize: 10, // 列表默认显示条数
      taskId: '',
      captcha: '', // 验证码
      isBindQrcode: false, // 是否绑定公众号
      props: { label: 'insdetailname,exId|planId|productId', id: 'id', parentId: 'leveltype', isTree: false }
    }
  },
  created () {
    this.isUltimate && this.queryPartnerBranchList()
    if (this.exportSceneCategory) { // 判断是否存在存在导出功能
      this.currentTemplate = field.sceneCategory.find(item => +item.value === +this.exportSceneCategory)
      this.currentTemplate = { ...this.currentTemplate, childrens: [] }

      this.queryExportBusiSceneConfig(this.exportSceneCategory).then(data => {
        let _data = data.dto || []
        /* let _customTemplate = _data.filter(item => +item.sceneType === 2)
        let _defaultTemplate = _data.filter(item => +item.sceneType === 1 && item.sceneLabel === 'default')
        this.templateList = [..._defaultTemplate, ..._customTemplate] */
        this.getExportTemplates(_data)
      })
    }

    this.busiFieldsPage().then((data) => {
      this.originFields = data.datas
      if (+this.Pratner.isdataauthority === 1) { // 判断监管模式 dataAuthorityDisabled  监管模式 0：显示 1：不显示
        this.originFields = (data.datas || []).filter(item => +item.dataAuthorityDisabled === 0)
      }
      return this.busiSceneConfigPage(this.sceneCategory)
    }).then((data) => {
      this.sceneList = data.datas || []
      let _cScene = this.sceneList.find(item => item.sceneType === 2)
      this.haveCustomScene = !!_cScene
      _cScene && (this.custom = {
        scene: _cScene,
        searchList: _cScene && _cScene.configInfoDto['searchList'], // this.originFields.filter(item => +item.enableSearch === 1 && this.getSceneFieldIds(_cScene, 'searchList').includes(item.id)),
        availableList: _cScene && _cScene.configInfoDto['availableList']// this.originFields.filter(item => this.getSceneFieldIds(_cScene, 'availableList').includes(item.id))
      })
      let _sScene = this.sceneList.find(item => +item.sceneType === 1 && item.sceneName)
      this.system = {
        scene: _sScene,
        searchList: this.originFields.filter(item => +item.enableSearch === 1 && this.getSceneFieldIds(_sScene, 'searchList').includes(item.id)),
        availableList: this.originFields.filter(item => this.getSceneFieldIds(_sScene, 'availableList').includes(item.id))
      }
      if (!_cScene && _sScene) {
        this.custom = {
          scene: null,
          searchList: [..._sScene.configInfoDto['searchList']], // .filter((item, index) => index < 10),
          availableList: [..._sScene.configInfoDto.availableList]// .filter((item, index) => item.isFixed && index < 20)
        }
      }
      this.custom.searchList = this.initSelectedFields(this.custom.searchList)
      this.custom.availableList = this.initSelectedFields(this.custom.availableList, false)

      this.$emit('change', { custom: this.custom, system: this.system, total: this.queryTotal, summary: {} }) // 针对财务明细处理（批量匹配政策）
      // 获取保单号
      let query = this.$route.query
      if (query.ids) {
        this.fill1166Value(query.ids)
      }
    })
  },
  mounted () {
    let _this = this
    this.$nextTick(() => {
      _this.$once('hook:beforeDestroy', () => {
        console.time('destroy')
      })
      _this.$once('hook:destroyed', () => {
        console.timeEnd('destroy')
      })
    })
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER',
      'commonData'
    ]),
    userInfo () {
      return (this.CUSTOMER_LOGINCUSTOMER && this.CUSTOMER_LOGINCUSTOMER.data) || {}
    },
    Pratner () {
      return (this.userInfo && this.userInfo.Pratner) || ''
    },
    subdomain () {
      return (this.Pratner && this.Pratner.subdomain) || ''
    },
    isRole () {
      return this.subdomain === 'role'
    },
    isdataauthority () {
      return isDataAuthority()
    }
  },
  components: {
    yblCondition,
    templateFields
    // insuranceTypeTree
  },
  methods: {
    search () {
      // this.insDynamicQuery()
      this.querySearch()
    },
    reset () {
      console.log('this.custom.searchList = ', this.custom.searchList)
      const _fields = this.custom.searchList.reduce((result, item) => {
        const _item = this.originFields.find(field => `${field.tableName}_${field.fieldName}` === `${item.tableName}_${item.fieldName}`)

        if (_item) {
          if ([8, 11].includes(+_item.frontEleType)) {
            let month = day.getCurrentMonth()
            if (['60', '50', '130', '7'].includes(this.sceneCategory)) {
              // month[0] = day.now(month[1]).add(-1, 'M').format('YYYY-MM-DD')
              month = day.getBeforeMonth(2)
            }
            _item.defaultVal = +_item.frontEleType === 8 ? `${month[0]},${day.nowF()}` : `${month[0]} 00:00:00,${day.nowF()} 23:59:59`
          } else if ([9].includes(+_item.frontEleType)) {
            _item.defaultVal = '0,0'
          }
          result.push(_item)
        }
        return result
      }, [])
      const fields = this.initSelectedFields(_fields)

      this.custom.searchList = [...fields]
    },
    querySearch (item) {
      if (this.isFeiche) { // 非车
        this.queryPageInsuranceinfoNew(item)
      } else {
        this.insDynamicQuery(item)
      }
    },
    pageChange (item) {
      // this.insDynamicQuery(item)
      this.querySearch(item)
      this.$emit('pageChange')
    },
    open () {
      let index = +this.dialog.step - 1
      if (index < 2) {
        this.renderField = ['searchList', 'availableList'][index]
        this.dialog.title = ['查询条件设置', '列表字段设置'][index]
      }
      this.dialog.width = +this.dialog.step === 40 ? '80%' : '60%'
      if (+this.dialog.step === 400) {
        this.dialog.width = '300px'
        this.dialog.title = '扫码绑定公众号'
      }
      this.dialog.visible = true
    },
    close () {
      this.dialog.step = 1
      this.dialog.visible = false
    },
    dialogSubmit () {
      this.$refs['dialog'].submit()
    },
    openColumn () {
      this.dialog.step = 2
      this.getRightFields()
      this.open()
    },
    getSceneFieldIds (scene, field) {
      return ((scene && scene.configInfoDto[field]) || []).map(item => item.id)
    },
    getRightFields () {
      if (+this.dialog.step === 2) {
        let temp = new Map()
        let _sScene = this.sceneList.find(item => item.sceneType === 1)
        let _data = this.originFields.filter(item => this.getSceneFieldIds(_sScene, 'availableList').includes(item.id))
        this.system.availableList = _data.reduce((prev, item) => {
          if (!temp.has(item.groupName)) {
            let children = _data.filter(child => child.groupName === item.groupName)
            let checkedItems = []
            temp.set(item.groupName, 1)
            let _item = { ...item }
            _item.children = [...children]
            _item.checkAll = children.length === checkedItems.length
            _item.isIndeterminate = !!(checkedItems.length && !item.checkAll)
            _item.checkedItems = checkedItems
            prev.push({ ..._item })
          }
          return prev
        }, [])
      }
      console.log('this.system.availablleList = ', this.system.availableList)
    },
    addOrUpdateBusiSceneConfig (params) { // 添加场景
      return this.$store.dispatch('busiAddOrUpdateBusiSceneConfig', params).then(data => {
        console.log(data)
        return data
      })
    },
    submit (items) {
      let form = {
        configJson: '', // 字段配置,JSON串
        customerId: 0, // 会员id
        enableGlobal: 2, // 场景类型，1：系统 2：个人
        id: 0, // 主键id
        organizationIds: '',
        partnerId: 0, // 商户Id
        sceneCode: '', // 场景代码
        sceneDesc: '', // 场景描述
        sceneLabel: '', // 场景标签
        sceneName: '', // 场景名称
        status: 1, // 状态 1：有效 2：禁用
        version: 0,
        sceneCategory: this.sceneCategory// '30'// 场景使用类型 1：保单查询 2:保单导出 3：上游结算报表查询 4：上游结算报表导出 5：财务明细报表查询 6：财务明细报表导出

      }
      let fieldsOrderDto = { // 排序规则
        ascend: 0, // 排序规则 1升序 0降序
        fieldId: '', // 字段id
        fieldName: '' // 字段名
      }
      if (this.dialog.step === 1) {
        this.custom.searchList = this.initSelectedFields(items, true, true, true)
      } else {
        this.custom.availableList = this.initSelectedFields(items, false, false, true) // _items
      }
      let configInfoDto = {
        availableList: this.custom.availableList.map(item => ({
          id: item.id
        })), // this.selectedFields,
        searchList: this.custom.searchList.map(item => {
          let _item = this.system.searchList.find(c => c.id === item.id)
          return {
            id: item.id,
            showName: item.showName,
            defaultVal: (_item && _item.defaultVal) || ''
          }
        }), // this.selectedItems,
        fieldsOrderDto: {
          ascend: fieldsOrderDto.ascend,
          fieldId: fieldsOrderDto.fieldId,
          fieldName: fieldsOrderDto.fieldName
        }
      }
      form.configInfoDto = configInfoDto
      form.id = (this.custom.scene && this.custom.scene.id) || 0
      console.log('formm = ', form)
      this.addOrUpdateBusiSceneConfig(form).then(({ data }) => {
        if (form.id === 0) {
          this.custom.scene = data
          this.haveCustomScene = true
        }
        this.close()
      })
    },
    busiSceneConfigPage (sceneCategory) {
      let index = 0
      let size = 100
      let params = {
        OrganizationIds: '',
        enableGlobal: 0,
        organizationIds: '',
        paging: {
          Ascending: true,
          DataCount: 0,
          OrderBy: '',
          SkipCount: index * size,
          TakeCount: size
        },
        roleId: 0,
        sceneCategory: sceneCategory, // 场景使用类型 1：保单查询 2:保单导出 3：上游结算报表查询 4：上游结算报表导出 5：财务明细报表查询 6：财务明细报表导出
        sceneType: '', // 场景类型，1：系统 2：个人
        status: 1 // 状态 1：有效 2：禁用
      }
      return this.$store.dispatch('busiBusiSceneConfigPage', params).then(data => {
        console.log(data)
        return data
      })
    },
    busiFieldsPage () {
      let params = {
        fieldName: '', // 字段名
        fieldType: '', // 字段类型
        groupName: '', // 字段分类
        isTabFilter: '', // 是否支持点选 1：支持，0：不支持
        roleIds: '', // 适用角色
        showName: '', // 显示名称
        busiType: this.isFeiche ? 200 : 5, // 业务类型 1：保单 2：政策 5 新保单字段 // sceneCategory = 7 表示非车
        status: 1, // 状态 1：启用 2：禁用
        modelType: this.isFeiche ? 2 : 1 // 1 车险 2 非车
      }
      return this.$store.dispatch('busiBusiFieldsPage', params).then(data => {
        return data
      })
    },
    /**
     * items : 过滤的数据源 isSearch 是否是筛选条件 （否，展示列表）
     */
    initSelectedFieldsOld (items, isSearch = true, isCalc = true, isSubmit = false) {
      let originFields = this.originFields
      if (+this.Pratner.isdataauthority === 1) { // 判断监管模式 dataAuthorityDisabled  监管模式 0：显示 1：不显示
        originFields = this.originFields.filter(item => +item.dataAuthorityDisabled === 0)
      }

      /* if (!isSearch) {
        // 判断 显示字段 不显示政策ID相关字段
        items = items.filter(item => ![1578, 1579, 1580, 1577, 1582, 1581, 1576].includes(item.id))
      } */

      let tempFields = []
      let data = items.reduce((arr, cur) => {
        let isExist = arr.find(item => item.id === cur.id) // 判断是否有重复数据
        if (!isExist) {
          let tempField = originFields.find(item => item.id === cur.id)
          if (!this.haveCustomScene) {
            if (isSubmit) { // 是否提交操作
              // tempField = originFields.find(item => item.id === cur.id)
            } else {
              tempField = originFields.find(item => +item.isFixed === 1 && item.id === cur.id)
            }
          }

          if (tempField) {
            tempField = { ...tempField, defaultVal: cur.defaultVal }
            // isSearch && this.dynamicLoadData(tempField)
            // console.log('tempField = ', tempField)
            const _dataSource = this.dynamicDataList[tempField.id]
            if (isSearch || (tempField.sourceType === 1 && (!_dataSource || _dataSource.length === 0))) {
              this.dynamicLoadData(tempField, isSearch)
            }
            if ([8, 11].includes(+tempField.frontEleType) || +tempField.isMutiSelect === 1) {
              let _defaultVal = tempField.defaultVal || []
              tempField.defaultVal = Array.isArray(_defaultVal) ? _defaultVal : _defaultVal.split(',')
            }
            arr.push(tempField)
          } else if (!isSearch) {
            tempField = originFields.find(item => item.id === cur.id)
            if (tempField) {
              tempField = { ...tempField, defaultVal: cur.defaultVal }
              tempFields.push(tempField)
            }
          }
        }
        return arr
      }, [])

      if (!isSearch && this.haveCustomScene) {
        data = [...data, ...tempFields]
        let filterData = [...data]
        if (!this.haveCustomScene && isCalc) {
          let fixedData = data.filter(item => +item.isFixed === 1)
          let len = fixedData.length
          if (len < 20) {
            let ids = fixedData.map(item => item.id)
            filterData = data.filter(item => !ids.includes(item.id)).filter((item, index) => index < 20 - len)
            filterData = [...fixedData, ...filterData]
          }
        }
        data = [...filterData]
      }
      // console.log('data=', data, this.dynamicDataList, items)
      return data
    },
    /**
     * items : 过滤的数据源 isSearch 是否是筛选条件 （否，展示列表）
     */
    initSelectedFields (items, isSearch = true, isCalc = true, isSubmit = false) {
      let originFields = this.originFields
      if (+this.Pratner.isdataauthority === 1) { // 判断监管模式 dataAuthorityDisabled  监管模式 0：显示 1：不显示
        originFields = this.originFields.filter(item => +item.dataAuthorityDisabled === 0)
      }

      let tempFields = []
      let data = items.reduce((arr, cur) => {
        let isExist = arr.find(item => item.id === cur.id) // 判断是否有重复数据
        if (!isExist) {
          let tempField = originFields.find(item => item.id === cur.id)
          if (!this.haveCustomScene) {
            if (isSubmit) { // 是否提交操作
              // tempField = originFields.find(item => item.id === cur.id)
            } else {
              tempField = originFields.find(item => +item.isFixed === 1 && item.id === cur.id)
            }
          }

          if (tempField) {
            tempField = { ...tempField, defaultVal: cur.defaultVal }
            const _dataSource = this.dynamicDataList[tempField.id]
            if (isSearch || (tempField.sourceType === 1 && (!_dataSource || _dataSource.length === 0))) {
              this.dynamicLoadData(tempField, isSearch)
            }
            if ([8, 11].includes(+tempField.frontEleType) || +tempField.isMutiSelect === 1) {
              const _defaultVal = tempField.defaultVal || []
              tempField.defaultVal = Array.isArray(_defaultVal) ? _defaultVal : _defaultVal.split(',')
            }
            arr.push(tempField)
          } else if (!isSearch) {
            tempField = originFields.find(item => item.id === cur.id)
            if (tempField) {
              tempField = { ...tempField, defaultVal: cur.defaultVal }
              tempFields.push(tempField)
            }
          }
        }
        return arr
      }, [])

      if (!isSearch) {
        data = [...data, ...tempFields]
        let filterData = [...data]
        if (!this.haveCustomScene && isCalc) {
          let fixedData = data.filter(item => +item.isFixed === 1)
          let len = fixedData.length
          if (len < 20) {
            let ids = fixedData.map(item => item.id)
            filterData = data.filter(item => !ids.includes(item.id)).filter((item, index) => index < 20 - len)
            filterData = [...fixedData, ...filterData]
          } else {
            filterData = [...fixedData]
          }
        }
        data = [...filterData]
      }
      // console.log('data=', data, this.dynamicDataList, items)
      return data
    },
    dynamicLoadData (item, isTree = true, request = false) {
      if ((+item.sourceType === 1 && !item.dictList) || item.sourceType === undefined) {
        let callConfig = item.callConfig && JSON.parse(item.callConfig)
        if (callConfig && callConfig.Url) {
          let url = callConfig.Url
          let fieldId = item.id
          if (!isTree) {
            url = url.split('?')[0]
            fieldId = `${fieldId}__1`
          }
          let key = `${this.userInfo.CustomerId}_${url}`
          let params = {}
          if (+item.id === 1163 && +this.productType === 2) { // 特殊处理保险公司 在此页面获取所有保司（非车+车险）
            key += `_all`
            params = {
              params: {
                filterWithJob: 0,
                partnerLevel: -1
              }
            }
          }
          let originData = this.dynamicDataList[fieldId] || this.commonData[`${key}`]

          if (request) {
            originData = null
          }
          if (!originData) { // && !url.includes('/customer/GetSmallOrganization') 判断组织机构情况不发送请求（组织机构组件内会重新请求数据）
            this.getRequest(url, params).then(data => {
              if (url.includes('/getSmallSuppliers')) { // 针对保险公司数据特殊处理
                data && this.$store.dispatch('setCommon', { key: key, value: data })
              }
              return data
            }).then(data => {
              this.initDynamicData(data, isTree, item)
            })
          } else {
            this.initDynamicData(originData, isTree, item)
          }
        }
      }
      // return item
    },
    getRequest (url, params = {}) {
      return request.base(null, { url: url, method: 'post', showLoading: true, ...params }).then(data => {
        return data.datas || (data.data && [data.data]) || data.data
      })
    },
    initDynamicData (data, isTree, item) {
      let fieldId = item.id
      if (!isTree) {
        fieldId = `${fieldId}__1`
      }
      this.dynamicDataList[`${fieldId}`] = data || []
      if (isTree) {
        item.dictList = (data && data.filter((item, index) => item.IsShow)) || [] // || [data.data] && index < 20
        if (item.id === 1394) {
          console.log('item.dictList = ', item.dictList)
        }
        if (+item.isMutiSelect === 0) {
          // 单选
          item.dictList = item.dictList.filter((item, index) => index < 20)
        }
        if (item.defaultVal !== '' && item.defaultVal !== null) {
          let defaultVal = Array.isArray(item.defaultVal) ? item.defaultVal : ((item.defaultVal && item.defaultVal.split(',')) || [])
          let selectedItem = (data || []).filter(c => defaultVal.includes(`${c.Value}`))
          let dictList = item.dictList.filter(c => !defaultVal.includes(c.Value))
          item.dictList = [...selectedItem, ...dictList]
          console.log('item = ', item.defaultVal)
        }
      }
    },
    getLabel (item, optionItem) {
      let label = optionItem.keyVal || optionItem.Label
      if (+item.id === 1163) { // 保险公司特殊处理
        let letter = (optionItem.Title || '').substring(0, 1).toUpperCase()
        label = `${letter}-${label}`
      }
      return label
    },
    treeClear (item) {
      this.$refs[`stree_${item.id}`][0].resetChecked()
    },
    radioChange (val) {
      // this.insDynamicQuery()
      this.querySearch()
    },
    filterEvent (val) {
      console.log(val, this.currentSelectedItem)
      if (+this.currentSelectedItem.sourceType === 1) {
        let originData = this.dynamicDataList[this.currentSelectedItem.id]
        let list = originData
        /* if (+this.currentSelectedItem.id !== 1163) { // 保险公司特殊处理
          list = originData.filter((item, index) => index < 20)
        } */

        val = val.toLowerCase()
        if (val) {
          list = originData.filter(item => `${item.Label}${item.Title || ''}`.toLowerCase().indexOf(val) !== -1)
          if (+this.currentSelectedItem.id === 1163 && val.length === 1) {
            // 保险公司特殊处理
            list = originData.filter(item => (item.Title || '').substring(0, 1).toLowerCase() === val)
          }
        }
        this.currentSelectedItem.dictList = list
      }
    },
    focusEvent (item) {
      console.log('item = ', item)
      this.currentSelectedItem = item
      if (+item.sourceType === 1) {
        let id = this.currentSelectedItem.id
        let originData = this.dynamicDataList[id]
        let relationFilterData = this.dynamicDataList[`${id}_filter`] // 处理筛选联动数据
        let originList = relationFilterData || originData // 原始数据
        let list = [...originList]
        if (+item.id !== 1163) { // 保险公司特殊处理
          let len = (item.defaultVal && item.defaultVal.length) || 0 // 判断已经选中的值显示
          if (+item.isMutiSelect === 0) { // 单选
            list = list.filter((c, index) => !(item.defaultVal || []).includes(c.Value) && index < (20 - len))
          } else {
            list = list.filter((c, index) => !(item.defaultVal || []).includes(c.Value))
          }
          if (len) {
            let selectedList = originList.filter(c => item.defaultVal.includes(c.Value))
            list = [...selectedList, ...list]
          }
          if (+item.id === 1394) { // 工号
            /* if (!len) { // 判断当工号已选择项，不需要过滤状态已删除的数据
              list = list.filter(item => +item.Status === 0)// .filter((item, index) => index < 20)
            } */
            this.resetSelectedVal(item)
          }
        }
        this.currentSelectedItem.dictList = list.filter(item => item.IsShow) // 根据返会数据过滤
      }
    },
    resetSelectedVal (item) {
      if (+item.sourceType === 1) {
        let id = item.id
        let originData = this.dynamicDataList[id]
        let relationFilterData = this.dynamicDataList[`${id}_filter`] // 处理筛选联动数据
        let list = relationFilterData || originData

        if (+item.id === 1394) { // 工号 目前只针对工号处理（如果需要全局匹配，需要给工号字段添加标识，数据来源关联关系）
          if (item.isMutiSelect) {
            // 多选的情况
            if (item.defaultVal) {
              let ids = list.map(item => (item.keyCode || item.Value))
              console.log('item=', item)
              let result = item.defaultVal.reduce((sum, val) => {
                if (ids.includes(val)) {
                  sum.push(val)
                }
                return sum
              }, [])
              item.defaultVal = result
            }
          } else {
            if (item.defaultVal !== '' && item.defaultVal !== null) {
              let _tempField = list.find(field => (field.keyCode || field.Value) === item.defaultVal)
              !_tempField && (item.defaultVal = '')
            }
          }
        }
      }
    },
    relationChange (val, item) {
      console.log(val, item)
      const dataConfig = item.dataConfig
      if (dataConfig) {
        let _dataConfig = JSON.parse(dataConfig)
        // console.log(_dataConfig)
        let related = _dataConfig.related
        if (!Array.isArray(val)) {
          val = [val]
        }
        if (+item.sourceType === 1) {
          let originData = this.dynamicDataList[related.ctlId] || []
          let list = originData.filter(item => val.includes(item[related.filterField]))

          let relationItem = this.custom.searchList.find(item => +item.id === +related.ctlId)

          if (relationItem) {
            this.dynamicDataList[`${relationItem.id}_filter`] = val.length === 0 ? null : list
          }

          // 处理保险公司切换关联的工号默认值变化
          this.custom.searchList.forEach(field => {
            if (+field.id === +related.ctlId) {
              this.resetSelectedVal(field)
            }
          })
        }
      }
    },
    calcFieldText (fieldId, row, item = '', index) {
      let val = row.fields[fieldId]
      if (index === 0) {
        // console.log('val=', val, fieldId, this.dynamicDataList, item)
      }
      if (+fieldId === 1196) { // 1196 全部组织机构
        if (val) {
          let array = JSON.parse(val)
          array.pop()
          val = array.map(item => item.organizationName).join('/')
        }
        return val
      }
      /**
       * 特殊处理：
       * 1174 业务员姓名、1176 出单员姓名、1397 业务员、1398 出单员
       * 1261 佣金结算方式
      */
      if ([1174, 1176, 1397, 1398, 1261].includes(+fieldId)) {
        return val
      }
      /**
       * 特殊处理 非车 工号的显示
       */
      // if (+fieldId === 1394 && +row.insuranceType === 20) {
      //   return val || '-'
      // }

      let dataSource = this.dynamicDataList[fieldId] // .find(item => +item.id === +fieldId)
      /* if (index === 0) {
        console.log('========', dataSource)
      } */
      if (!dataSource || (+item.frontEleType === 10 && dataSource.length === 1)) {
        let obj = this.originFields.find(item => +item.id === +fieldId)
        if (+obj.sourceType === 2) { // 静态字典数据
          dataSource = obj.dictList
        } else {
          obj.dictList = null
          if (+fieldId === 1394) { // 渲染工号名称
            let url = '/jobNo/getSmallJobNoList'
            let key = `${this.userInfo.CustomerId}_${url}_all`
            dataSource = this.commonData[`${key}`]
          } else {
            index === 0 && this.dynamicLoadData(obj, false)
            dataSource = this.dynamicDataList[`${fieldId}__1`] || this.dynamicDataList[fieldId] // item && item.dictList
          }
        }
      }
      // console.log('dataSource=', dataSource, fieldId)
      let dictList = dataSource || [] // && dataSource.dictList
      /* if (index === 0 && +fieldId === 1162) {
        console.log('>>>>>>>>>>>>dictList = ', dictList)
      } */
      if (dictList.length === 0) {
        dictList = this.dynamicDataList[`${fieldId}__1`] || this.dynamicDataList[fieldId] || []
      }
      let field = dictList && dictList.filter(item => (`${val}` || '').split(',').includes(item.keyCode || item.Value))
      if (field.length === 0) {
        // 判断是否有对应的返回值
        // 如果没有拿系统设置的默认值去判断，如果默认值为空直接返回‘-’
        if (item.defaultVal || item.defaultVal === '0') {
          field = dictList && dictList.filter(dict => (`${item.defaultVal}` || '').split(',').includes(dict.keyCode || dict.Value))
        } else {
          return '-'
        }
      }
      if (field.length === 0) {
        return '-'
      }
      return (field && field.map(item => (item.keyVal || item.Label)).join(',')) || val
    },
    insDynamicQuery (item) {
      let size = (item && item.size) || this.pageSize
      let index = (item && item.page - 1) || 0
      let searchFields = this.custom.searchList.map(item => {
        let val = Array.isArray(item.defaultVal) ? (item.defaultVal === ['', ''] ? '' : item.defaultVal.join(',')) : (item.defaultVal === [] ? '' : item.defaultVal)
        return {
          fieldId: item.id,
          operateType: '',
          val: val
        }
      })

      /* let date = searchFields.filter(item => [1402, 1648].includes(+item.fieldId)) // 日期类型 [8,11].includes(item.frontEleType)
      if (date && date.length) {
        if (!date[0].val) {
          this.$alert('请选择或输入日期区间段')
          return
        }
      } */
      console.log('searchFields=', searchFields)
      let newSearchCondition = JSON.stringify(searchFields)
      let loadSummary = true// (item && item.isDelete) || this.currentSearchCondition !== newSearchCondition // item.isDelete 表示是否删除后查询
      this.currentSearchCondition = newSearchCondition
      let scene = this.custom.scene// tabList[+this.sceneIndex]
      let { configInfoDto } = scene || this.system.scene
      let { fieldsOrderDto } = configInfoDto
      let partnerIds = this.partner.defaultVal
      if (this.partner.defaultVal && this.partner.defaultVal.length === 0) {
        partnerIds = this.partner.originBranchList.map(item => item.partnerId)
      }
      let params = {
        sceneId: (scene && scene.id) || this.system.scene.id,
        searchFields: searchFields,
        sortField: {
          ascend: fieldsOrderDto.ascend, // 升序降序
          fieldId: fieldsOrderDto.fieldId // 排序列Id
        },
        Paging: {
          Ascending: this.Ascending,
          DataCount: 0,
          OrderBy: this.OrderBy,
          SkipCount: index * size,
          TakeCount: size
        },
        partnerIds: this.isUltimate ? partnerIds.join(',') : this.Pratner.partnerid, // 20001//
        loadFlag: {
          loadSummary: loadSummary
        },
        supportMultiPartner: this.isUltimate,
        dynamicQueryType: this.dynamicQueryType
      }

      // console.log('params=', params)
      return this.$store.dispatch('insuranceInsDynamicQuery', params).then(data => {
        console.log(data)
        this.queryList = data.Datas
        this.queryTotal = data.Paging.DataCount
        loadSummary && (this.sumInsuranceInfo = data.Summary)
        this.$emit('change', { total: this.queryTotal, summary: data.Summary, params: params, tables: this.queryList, custom: this.custom, system: this.system })
      })
    },
    queryPageInsuranceinfoNew (item) {
      let size = (item && item.size) || this.pageSize
      let index = (item && item.page - 1) || 0
      let searchFields = this.custom.searchList.map(item => ({
        fieldId: item.id,
        operateType: '',
        val: Array.isArray(item.defaultVal) ? (item.defaultVal === ['', ''] ? '' : item.defaultVal.join(',')) : (item.defaultVal === [] ? '' : item.defaultVal)
      }))

      console.log('searchFields=', searchFields)
      let newSearchCondition = JSON.stringify(searchFields)
      let loadSummary = true // (item && item.isDelete) || this.currentSearchCondition !== newSearchCondition // item.isDelete 表示是否删除后查询
      this.currentSearchCondition = newSearchCondition
      let scene = this.custom.scene// tabList[+this.sceneIndex]
      let { configInfoDto } = scene || this.system.scene
      let { fieldsOrderDto } = configInfoDto
      let params = {
        sceneId: (scene && scene.id) || this.system.scene.id,
        searchFields: searchFields,
        sortField: {
          ascend: fieldsOrderDto.ascend, // 升序降序
          fieldId: fieldsOrderDto.fieldId // 排序列Id
        },
        Paging: {
          Ascending: this.Ascending,
          DataCount: 0,
          OrderBy: this.OrderBy,
          SkipCount: index * size,
          TakeCount: size
        },
        partnerIds: this.Pratner.partnerid, // 20001//
        loadFlag: {
          loadSummary: loadSummary
        }
      }
      return this.$store.dispatch('insurancefcQueryPageInsuranceinfoNew', params).then(data => {
        console.log(data)
        let { PageInfo, QuerySumInsuranceInfoNewDto } = data
        this.queryList = data.Datas || []
        this.queryTotal = PageInfo.DataCount || 0
        loadSummary && (this.sumInsuranceInfo = QuerySumInsuranceInfoNewDto)
        this.$emit('change', { total: this.queryTotal, summary: QuerySumInsuranceInfoNewDto, params: params, tables: this.queryList, custom: this.custom, system: this.system })
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.$emit('selection-change', val)
    },
    viewPolicy (row) {
      let url = ''
      let isCross = true
      if (+row.insuranceType === 20) {
        isCross = false
        url = `/policy/match/detail?InsuranceId=${row.insuranceId}&HasEditFee=${row.hasEditFee}&policyFcBranchId=${row.fields[1577] || ''}`
      } else if (!this.renderPolicy(row)) {
        url = `Rule/MatchBatchOrRuleLog?InsuranceId=${row.insuranceId}&HasEditFee=${row.hasEditFee}&InsSupplierId=${row.fields[1163] || 0}`
      } else {
        let params = []
        let setInfo = row.fields
        if (setInfo[1580]) {
          params.push({ id: setInfo[1580], type: 0 })
        } else if (setInfo[1577]) {
          params.push({ id: setInfo[1577], type: 0 })
        }

        if (setInfo[1581]) {
          params.push({ id: setInfo[1581], type: 1 })
        }
        if (setInfo[1582]) {
          params.push({ id: setInfo[1582], type: 2 })
        }
        url = `/Rule/OneInfo?p=${JSON.stringify(params)}`
      }
      openNavUrl(url, '关联政策', location.host, 'blank', isCross, 0, 'n11116')
    },
    renderPolicy (row) {
      if (+row.insuranceType === 20) {
        return row.fields[1577] && +row.fields[1577] > 0 && +row.hasEditFee === 0
      }
      return [1580, 1577, 1581, 1582].some(item => row.fields[item] && +row.fields[item] > 0)
    },
    handleCommand (command) {
      this.currentCommand = command
      switch (command) {
        case 'addTemplate':
          this.dialog.step = 40
          this.dialog.title = `新增${this.currentTemplate.label}`
          this.open()
          break
        case 'none':
          break
        default:
          /* this.addExportTask(command).then((data) => {
            this.taskId = data.data
            this.dialog.step = 50
            this.open()
          }) */
          this.dialog.step = 400
          this.open()
          break
      }
    },
    inputChange (val) {
      this.debounce()(val, this)
    },
    debounce: tool.debounce(function (val, that) {
      that.filterTemplate(val)
    }, 200, this),
    filterTemplate (val) {
      if (!val) {
        this.templateList = [...this.originTemplates]
        return
      }
      this.templateList = this.originTemplates.filter(item => item.sceneName.includes(val))
    },
    nextValidate (item, openId) {
      if (item === 'change') {
        this.dialog.title = '安全验证'
        this.isBindQrcode = true
      } else {
        this.captcha = item === 'continue' ? '' : item
        this.addExportTask(this.currentCommand).then((data) => {
          this.taskId = data.data
          this.dialog.step = 50
          this.open()
        })
      }
    },
    addExportTask (exportSceneId) {
      let size = 10
      let index = 0
      /* let searchFields = this.custom.searchList.map(item => ({
        fieldId: item.id,
        operateType: '',
        val: Array.isArray(item.defaultVal) ? (item.defaultVal === ['', ''] ? '' : item.defaultVal.join(',')) : (item.defaultVal === [] ? '' : item.defaultVal)
      })) */
      let searchFields = this.custom.searchList.map(item => {
        let val = Array.isArray(item.defaultVal) ? (item.defaultVal === ['', ''] ? '' : item.defaultVal.join(',')) : (item.defaultVal === [] ? '' : item.defaultVal)
        return {
          fieldId: item.id,
          operateType: '',
          val: val
        }
      })

      console.log('searchFields=', searchFields)
      let newSearchCondition = JSON.stringify(searchFields)
      let loadSummary = this.currentSearchCondition !== newSearchCondition
      this.currentSearchCondition = newSearchCondition
      let scene = this.custom.scene// tabList[+this.sceneIndex]
      let { configInfoDto } = scene || this.system.scene
      let { fieldsOrderDto } = configInfoDto
      const { configInfoDto: configInfo } = this.system.scene
      const { fieldsOrderDto: dto } = configInfo
      let partnerIds = this.partner.defaultVal
      if (this.partner.defaultVal && this.partner.defaultVal.length === 0) {
        partnerIds = this.partner.originBranchList.map(item => item.partnerId)
      }
      let searchParams = {
        sceneId: (scene && scene.id) || this.system.scene.id,
        searchFields: searchFields,
        sortField: {
          ascend: fieldsOrderDto.ascend || dto.ascend, // 升序降序
          fieldId: fieldsOrderDto.fieldId || dto.fieldId // 排序列Id
        },
        Paging: {
          Ascending: this.Ascending,
          DataCount: 0,
          OrderBy: this.OrderBy,
          SkipCount: index * size,
          TakeCount: size
        },
        partnerIds: this.isUltimate ? partnerIds.join(',') : this.Pratner.partnerid, // 20001//
        loadFlag: {
          loadSummary: loadSummary
        },
        supportMultiPartner: this.isUltimate,
        dynamicQueryType: this.dynamicQueryType
      }
      let params = {
        addTime: '', // 添加时间
        busiParam: JSON.stringify(searchParams), // 请求json
        busiSceneId: searchParams.sceneId, // 场景id
        busiType: this.isFeiche ? 200 : this.sceneCategory, // '1', // 业务类型 1:场景保单导出 // sceneCategory = 7 表示非车
        clientIP: '',
        curRecord: '', // 当前已导出记录数、分页请求
        customerId: '', // 商户ID
        detail: '', // 明细信息
        fileId: '', // attachmentfile id
        fileName: '', // 文件名称
        partnerId: '', // 商户ID
        remark: '',
        startTime: '', // 开始执行时间
        status: '', // 状态 -1：已删除 1：待处理 2：处理中 4：成功 16：已取消
        taskId: '', // 任务ID
        taskType: '0', // 任务类型 0：导出 1：导入
        title: '',
        totalRecord: '', // 导出记录数
        updateTime: '', // 更新时间
        userId: '',
        userName: '',
        exportSceneId: exportSceneId // 导出场景id
      }
      params.headers = {
        'captcha': this.captcha
      }
      console.log('🚀 ~ file: DynamicQuery.vue:1248 ~ addExportTask ~ params:', params)
      return this.$store.dispatch('exportAddExportTask', params).then(data => {
        console.log(data)
        return data
      })
    },
    submitTemplate (item) {
      console.log(item)
      let _items = item.items.reduce((arr, cur) => {
        arr = [...arr, ...cur.checkedItems]
        return arr
      }, [])

      let form = {
        configJson: '', // 字段配置,JSON串
        customerId: 0, // 会员id
        enableGlobal: this.isRole ? 1 : 2, // 场景类型，1：系统 2：个人
        id: 0, // 主键id
        organizationIds: '',
        partnerId: 0, // 商户Id
        sceneCode: '', // 场景代码
        sceneDesc: '', // 场景描述
        sceneLabel: this.isRole ? 'default' : '', // 场景标签
        sceneName: item.sceneName, // 场景名称
        status: 1, // 状态 1：有效 2：禁用
        version: 0,
        orgAuthorization: item.orgAuthorization && Array.isArray(item.orgAuthorization) ? item.orgAuthorization.join(',') : item.orgAuthorization, // 授权组织
        sceneCategory: this.exportSceneCategory// 场景使用类型 1：保单查询 2:保单导出 3：上游结算报表查询 4：上游结算报表导出 5：财务明细报表查询 6：财务明细报表导出

      }
      const { fieldsOrderDto: dto } = item
      const fieldsOrderDto = { // 排序规则
        ascend: dto.ascend || 0, // 排序规则 1升序 0降序
        fieldId: dto.fieldId || '', // 字段id
        fieldName: '' // 字段名
      }
      const configInfoDto = {
        availableList: _items.map(item => ({
          id: item.id
        })), // this.selectedFields,
        searchList: [], // this.selectedItems,
        fieldsOrderDto: {
          ascend: fieldsOrderDto.ascend,
          fieldId: fieldsOrderDto.fieldId,
          fieldName: fieldsOrderDto.fieldName
        }
      }
      form.configInfoDto = configInfoDto
      form.id = item.sceneId
      this.addOrUpdateBusiSceneConfig(form).then(({ data }) => {
        this.refresh()
      })
    },
    refresh () {
      this.queryExportBusiSceneConfig(this.exportSceneCategory).then(data => {
        // this.templateList = data.dto || []
        this.getExportTemplates(data.dto || [])
        this.close()
      })
    },
    getExportTemplates (data) {
      let _customTemplate = data.filter(item => +item.sceneType === 2)
      let _defaultTemplate = data.filter(item => +item.sceneType === 1 && item.sceneLabel === 'default')
      this.templateList = [..._defaultTemplate, ..._customTemplate]
      this.originTemplates = [...this.templateList]
      this.originTemplateList = data
    },
    queryExportBusiSceneConfig (id) {
      let params = {
        sceneCategory: id, // 4：上游结算报表导出  6：财务明细报表导出 8 非车导出模版
        needAuthorization: false // 是否需要字段权限 true 显示，false 不显示
      }
      return this.$store.dispatch('busiQueryExportBusiSceneConfig', params).then(data => {
        console.log(data)
        return data
      })
    },
    editRow (row) {
      // &InsuranceNo=20210427004buyaodong&InsuranceLabel=0
      if (+row.insuranceType === 20) { // 非车保单信息
        this.redirect(row)
        return
      }
      // let url = `/insurance/edit?insuranceId=${row.insuranceId}`
      // window.open(url, '_blank')

      let url = `/Policy/Edit?InsuranceId=${row.insuranceId}`
      const id = ''// Math.random()
      openNavUrl(url, '保单信息', location.host, 'blank', true, 0, id)
    },
    deleteRow (row) {
      this.$confirm('您确定要删除此条数据信息？', '系统信息').then(data => {
        this.deleteIns(row).then(() => {
          let item = {
            isDelete: true // 表示删除操作
          }
          // this.insDynamicQuery(item)
          this.querySearch(item)
          this.$alert('保单删除成功')
        })
      }).catch(() => { })
    },
    deleteIns (row) {
      let params = {
        params: {
          insId: row.insuranceId, // 保单ID
          insNo: '', // 保单编号
          sId: '' // 保险公司ID
        }
      }
      return this.$store.dispatch('insuranceDeleteIns', params)
    },
    fill1166Value (value, filedId = 1166) { // 默认： 1166 保(批)单号
      let item = this.custom.searchList.find(item => +item.id === +filedId)
      item && (item.defaultVal = value)
    },

    goToDetail (row) {
      if (+row.insuranceType === 20) { // 非车保单信息
        this.redirect(row, true)
        return
      }
      let url = `/Policy/Detail?InsuranceId=${row.insuranceId}`
      if (+row.insuranceLabel === 1) { // 批单
        url = `${url}&Automatic=-99`
      }
      this.goToUrl(url, row)
    },
    redirect (row, readonly = false) {
      let data = {
        insuranceid: row.insuranceId,
        readOnly: readonly
      }
      this.$store.dispatch('setActive', data).then(() => {
        let path = 'insuranceCompile'
        if (+row.insuranceLabel === 1) {
          path = 'endorsementCompile'
        }
        openNavUrl(`/feiche/${path}?insuranceid=${row.insuranceId}&rom=${!readonly ? '2077' : Math.ceil(Math.random() * 10)}`, `非车保单详情`, location.host, 'blank', false, 0, 'n11006')
      })
    },
    goToUrl (url, row = '') {
      let host = window.location.origin
      let _blank = row ? 'blank' : 'self'
      let _title = row ? `保单${row.fields[1166] ? '[' : ''}${row.fields[1166] || ''} ${row.fields[1166] ? ']' : ''}详情` : ''
      openNavUrl(url, _title, host, _blank, true, 0, `${row.insuranceId}`)
    },
    goToRouter (url, target = 'blank') {
      if (target === 'blank') {
        openNavUrl(url, `保单任务列表`, location.host, 'blank', false, 0, 'n11006')
      } else {
        this.$router.push({ path: url })
      }
    },
    queryPartnerBranchList () {
      return this.$store.dispatch('partnerBranchQueryPartnerBranchList').then(data => {
        this.partner.branchList = (data.Data || [])// .map(item => item.partnerId)
        this.partner.originBranchList = (data.Data || [])
      })
    },
    filterPartner (val) {
      console.log('filter value = ', val)
      this.partner.branchList = this.partner.originBranchList
      if (val) {
        this.partner.branchList = this.partner.originBranchList.filter(item => item.partnerName.includes(val))
      }
    },
    focusPartner () {
      this.partner.branchList = this.partner.originBranchList
    },
    partnerChange (val) { },
    toggleRowSelection (row) {
      this.$refs['dynamicTable'].toggleRowSelection(row)
    },
    toggleAllSelection () {
      this.$refs['dynamicTable'].toggleAllSelection()
    },
    sizeChange (item) {
      this.pageSize = item.size
      this.$emit('size-change', item)
    },
    goTo () {
      this.close()
      let url = this.isFeiche ? '/feiche/policy/task' : `/insurance/task?busiType=${this.sceneCategory}`
      this.goToRouter(url)
    },
    openView (row) { // 针对负责人奖励比例特殊处理
      this.$emit('view', row)
    }
  }
}
</script>

<style lang="less">
.dynamic-query {
  .summary-info {
    padding: 5px 0;
    line-height: 25px+5px;
  }
  .inline {
    display: inline;
  }
  .el-button {
    &.disabled {
      color: #c0c4cc;
    }
    &.table-button {
      padding: 3px 8px;
    }
  }
  .ultimate-item {
    margin-left: -5px;
  }
  // .search-form {
  //   .el-form-item {
  //     width: 100%;
  //     &__label {
  //       min-width: 150px;
  //     }
  //   }
  // }
  // @media (min-width: 1024px) {
  //   .search-form {
  //     .el-form-item {
  //       width: 45%;
  //       &__label {
  //         min-width: 130px;
  //       }
  //     }
  //   }
  // } /*>=1024的设备*/

  // @media (min-width: 1100px) {
  //   // .search-form{font-size: 20px}
  // } /*>=1100的设备*/
  // @media (min-width: 1280px) {
  //   // .search-form{font-size: 22px;}
  // } /*>=1280的设备*/

  // @media (min-width: 1366px) {
  //   .search-form {
  //     .el-form-item {
  //       width: 32%;
  //       &__label {
  //         min-width: 130px;
  //       }
  //     }
  //   }
  // }

  // @media (min-width: 1440px) {
  //   // .search-form{font-size: 25px;}
  // }

  // @media (min-width: 1680px) {
  //   .search-form {
  //     .el-form-item {
  //       width: 24%;
  //       &__label {
  //         min-width: 130px;
  //       }
  //     }
  //   }
  // }
  // @media (min-width: 1920px) {
  //   // .search-form{font-size: 33px;}
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicQuery.vue